var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status-picker-page-template"},[_c('p',{staticClass:"title"},[_vm._v("\n      What describes you best ?\n  ")])])}]

export { render, staticRenderFns }